export default __webpack_public_path__ + "static/media/team_background2.3491f9af.png";